import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ProductDashboardLastReceivedModel } from "src/app/core/models/product-model/product-dashboard-model/product-dashboard-lastreceived.model";
import { PRODUCT_DASHBOARD_FEES_LASTRECEIVED_DEMO } from "./product-dashboard-fees-lastreceived-demo-data";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './product-dashboard-fees-lastreceived.component.html',
    selector: 'op-product-dashboard-fees-lastreceived'
})
export class ProductDashboardFeesLastReceivedComponent implements AfterViewInit {
    public lastReceivedInfo: ProductDashboardLastReceivedModel[];
    
    constructor(private changeDetection: ChangeDetectorRef) {
        
    }

    ngAfterViewInit(): void {
        this.loadData();
    }

    private loadData() {
        setTimeout(() => {
            this.lastReceivedInfo = PRODUCT_DASHBOARD_FEES_LASTRECEIVED_DEMO;
            this.changeDetection.detectChanges();
        }, 500);
    }
}